import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'
import fav32 from '../../assets/favicon-32.png'
import { formattedDomainName, baseUrl } from 'utils/parseDomain'

const Schema = props => {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(props.objSchema)}
      </script>
    </Helmet>
  )
}

function SeoData(props) {
  const baseSchema = {
    '@context': 'http://schema.org',
    name: formattedDomainName,
    url: baseUrl,
  }

  const webSchema = {
    ...baseSchema,
    '@type': 'WebSite',
  }

  const orgSchema = {
    ...baseSchema,
    '@type': 'Organization',
    contactPoint: [
      {
        '@type': 'ContactPoint',
        telephone: '+91 1860-200-3456',
        contactType: 'Customer Service',
      },
    ],
    logo: props.domainLogo,
    sameAs: [
      'https://www.facebook.com/shaadicom',
      'https://twitter.com/shaadidotcom',
      'https://www.youtube.com/user/shaaditv',
      'https://www.linkedin.com/company/people-interactive',
    ],
  }

  return (
    <StaticQuery
      query={detailsQuery}
      render={data => {
        const metaTitle = props.title || data.site.siteMetadata.title
        const metaDescription =
          props.description || data.site.siteMetadata.description
        const metaKeywords = props.keywords || data.site.siteMetadata.keywords
        return (
          <>
            <Helmet
              title={metaTitle}
              meta={[
                { name: `description`, content: metaDescription },
                { name: `keyword`, content: metaKeywords },
                { name: `robots`, content: `index, follow` },
                { property: `og:url`, content: baseUrl },
                { property: `og:title`, content: metaTitle },
                { property: `og:description`, content: metaDescription },
                { property: `og:image`, content: props.metaImage },
                { property: `twitter:url`, content: baseUrl },
                { property: `twitter:title`, content: metaTitle },
                { property: `twitter:description`, content: metaDescription },
                { property: `twitter:image`, content: props.metaImage },
              ]}
              link={[
                { rel: 'shortcut icon', type: 'image/png', href: `${fav32}` },
                { rel: 'canonical', href: baseUrl },
              ]}
            />
            <Schema objSchema={webSchema} />
            <Schema objSchema={orgSchema} />
          </>
        )
      }}
    />
  )
}

SeoData.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  keywords: PropTypes.string.isRequired,
  domainLogo: PropTypes.string.isRequired,
  metaImage: PropTypes.string.isRequired,
}

export default SeoData

const detailsQuery = graphql`
  query DefaultSeoQuery {
    site {
      siteMetadata {
        title
        description
        keywords
      }
    }
  }
`
